import * as Sentry from "@sentry/react"

// Runtime configuration injected by container start.sh
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      SENTRY_DSN?: string
      ENVIRONMENT?: string
    }
  }
}

// Initialize Sentry
export function initSentry() {
  // Try runtime config first (production), fallback to build-time (development)
  const dsn = window.__RUNTIME_CONFIG__?.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN
  const environment = window.__RUNTIME_CONFIG__?.ENVIRONMENT || import.meta.env.VITE_ENVIRONMENT || 'production'

  // Only initialize if DSN is provided
  if (!dsn) {
    console.warn('Sentry DSN not configured - error tracking disabled')
    return
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ block: ['[data-sentry-block]'] }),
    ],
    beforeBreadcrumb(breadcrumb) {
      const data = breadcrumb.data || {};
      if (String(data.url || '').includes('/distributors/') || String(breadcrumb.message || '').includes('/distributors/')) return null;
      return breadcrumb;
    },
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 10% of transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    // Environment
    environment,
  })

  console.log(`Sentry initialized for environment: ${environment}`)

  // Expose Sentry globally for testing
  if (typeof window !== 'undefined') {
    (window as any).Sentry = Sentry
  }
}

export { Sentry }
